/**
 * @module router/modules/report
 * @description 리포트/통계 라우트 모듈 — ADMIN 전용 `/report` 셸을 제공합니다.
 * meta.roles=['ADMIN'] 으로 roleGuard 가 비-ADMIN 진입을 /dashboard 로 리다이렉트합니다.
 */

const routes = [
  {
    path: '/report',
    name: 'Report',
    component: () => import(/* webpackChunkName: "report" */ '../../views/report/ReportView.vue'),
    meta: {
      title: '리포트/통계',
      platform: 'web',
      menuYn: true,
      authorization: true,
      roles: ['ADMIN']
    }
  }
]

export default routes
